<template>
    <v-sheet class="mb-5" style="background-color:#fff;">
        <!--v-toolbar app floating elevation="0" style="border-bottom:1px solid #ddd" pb-5-->
        <v-app-bar
            app
            dense
            fixed
            elevate-on-scroll
            style="border-bottom:1px solid #ddd; padding:0px; "
            elevation="0"
        >
            <v-btn :to="{name:'products'}" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>{{page_title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn @click="salvar_rascunho" text elevation="0" color="primary">
                        <v-icon>save</v-icon>&nbsp; Salvar Rascunho
                    </v-btn>&nbsp;
                    <v-btn v-if="['draft','editable_upgrade'].includes(product.status)" @click="distribuir()" dark small elevation="0" color="success">
                        <v-icon>call_split</v-icon>&nbsp; Distribuir
                    </v-btn>
                </template>
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn
                        @click="salvar_rascunho"
                        elevation="0"
                        color="primary"
                        text
                        outlined
                        dark
                        small
                    >
                        <v-icon>save</v-icon>
                    </v-btn>&nbsp;
                    <v-btn v-if="['draft','editable_upgrade'].includes(product.status)" @click="distribuir()" dark small elevation="0" color="success">
                        <v-icon>call_split</v-icon>
                    </v-btn>
                </template>
            </v-toolbar-items>
            <!--</v-toolbar-->
        </v-app-bar>

        <!--HELPER-->

        <v-layout wrap>
            <v-flex xs12 px-5>
               
                    <v-layout wrap mb-5 style=""><!--border:1px solid #ccc-->
                        <v-flex xs12 md12 lg8 mb-2>
                            <v-card elevation="0" mb-2>
                                <v-card-title style="color:#222; ">Produto</v-card-title>
                                <v-divider></v-divider>
                                <div>
                                    <v-form>
                                        <v-container mt-3 py-4 grid-list-xl>
                                            <v-layout wrap>
                                                <v-flex xs12 md12>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="Nome do Produto"
                                                        outlined
                                                        hint="Nome do produto que será disponibilizado nas plataformas digitais"
                                                        v-validate="'required'"
                                                        data-vv-name="product_name"
                                                        v-model="product.name"
                                                        append-outer-icon="help_outline"
                                                        color="blue"
                                                        @click:append-outer="help('product_name')"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md6>
                                                    <v-select
                                                        v-model="product.type"
                                                        v-validate="'required'"
                                                        :items="configs.product_types"
                                                        item-value="id"
                                                        item-text="name"
                                                        label="Formato de produto"
                                                        data-vv-name="type"
                                                        
                                                        outlined
                                                        :hint="'Selectione um formato para o projeto: Single, EP ou Álbum. Não sabe qual escolher? Clique no ícone <b>(?)<b>'"
                                                        append-outer-icon="help_outline"
                                                        @click:append-outer="help('product_type')"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-dialog
                                                        ref="dialog"
                                                        v-model="modal"
                                                        persistent
                                                        full-width
                                                        width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            
                                                            <v-text-field
                                                                v-model="formated_date"
                                                                label="Data de lançamento"
                                                                readonly
                                                                outlined
                                                                hint="É recomendável que a data de lançamento do produto seja de, no mínimo, 20 dias. Clique no ícone <b>(?)</b> para saber mais."
                                                                v-on="on"
                                                                :error-messages="errors.collect('release_date')"
                                                                data-vv-name="release_date"
                                                                v-validate="'required'"
                                                                append-outer-icon="help_outline"
                                                                @click:append-outer="help('product_release')"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="release_date"
                                                            locale="pt-br"
                                                            scrollable
                                                            :min="min_date_datepicker"
                                                            @change="saveDate"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="modal = false ; date=null"
                                                            >Cancelar</v-btn>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="modal=false"
                                                            >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-flex>

                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        label="Artista Principal"
                                                        class="purple-input"
                                                        outlined
                                                        hint="Nome que será utilizado em todas as plataformas"
                                                        v-model="artist.name"
                                                        disabled
                                                        append-outer-icon="help_outline"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md6>
                                                    <!--messages="Se não tiver pode deixar vazio, incluiremos o seu nome aqui."-->
                                                    <v-text-field
                                                        label="Gravadora / Distribuidora"
                                                        class="purple-input"
                                                        v-model="product.record_label_name"
                                                        disabled
                                                        outlined
                                                        append-outer-icon="help_outline"
                                                    />
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        label="Ano de Copyright"
                                                        class="purple-input"
                                                        v-model="product.copyright_year"
                                                        outlined
                                                        hint="Em geral, costuma-se utilizar o ano de produção do produto. Clique no ícone <b>(?)</b> para saber mais."
                                                        :error-messages="errors.collect('copyright_year')"
                                                        data-vv-name="copyright_year"
                                                        v-validate="'required'"
                                                        append-outer-icon="help_outline"
                                                        @click:append-outer="help('product_copyright_year')"
                                                    />
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        label="Copyright do Produto ©"
                                                        class="purple-input"
                                                        v-model="product.copyright"
                                                        outlined
                                                        hint="Nome da pessoa ou empresa que detém os direitos sobre o produto. Clique no ícone <b>(?)</b> para saber mais."
                                                        :error-messages="errors.collect('copyright')"
                                                        data-vv-name="copyright"
                                                        v-validate="'required'"
                                                        append-outer-icon="help_outline"
                                                        @click:append-outer="help('product_copyright')"
                                                    />
                                                </v-flex>
                                                <!--messages="Você pode alterar individualmente na faixa, caso haja mais de uma"-->
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        label="Copyright da Gravação ℗"
                                                        placeholder
                                                        class="purple-input"
                                                        v-model="product.copyright_phonogram"
                                                        outlined
                                                        hint="Pessoa, empresa ou estúdio que detém os direitos da gravação do seu produto. Clique no ícone <b>(?)</b> para saber mais."
                                                        :error-messages="errors.collect('copyright_phonogram')"
                                                        data-vv-name="copyright_phonogram"
                                                        v-validate="'required'"
                                                        append-outer-icon="help_outline"
                                                        @click:append-outer="help('product_copyright_phonogram')"
                                                    />
                                                </v-flex>

                                                <v-layout
                                                    px-2
                                                    mx-2
                                                    wrap
                                                    style="border:1px solid #ccc; background-color:#fefefe"
                                                >
                                                    <v-flex xs12 md6 align-self-center>
                                                        <v-radio-group v-model="product.own_upc">
                                                            <template v-slot:label>
                                                                <div>
                                                                    Esse produto já tem
                                                                    <strong>código de barras?</strong>
                                                                     <v-btn
                                                                        icon
                                                                            @click="help('product_upc')"
                                                                        ><v-icon>help_outline</v-icon></v-btn>
                                                                </div>
                                                            </template>
                                                            <v-radio :value="1">
                                                                <template v-slot:label>
                                                                    <div>Sim, já tem um válido.</div>
                                                                </template>
                                                            </v-radio>
                                                            <v-radio :value="0" default>
                                                                <template v-slot:label>
                                                                    <div>
                                                                        Não, gostaria de adquirir um válido por
                                                                        <u>R$ 39,99</u>
                                                                    </div>
                                                                </template>
                                                            </v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                    <v-flex xs12 md6 align-center align-self-center>
                                                        <v-text-field
                                                            :disabled="!is_item_disabled(product.own_upc)"
                                                            label="Código de barras"
                                                            class="purple-input"
                                                            outlined
                                                            hint="Se você tiver dúvidas clique no ícone (?)"
                                                            v-model="product.upc"
                                                            v-mask="'#############'"
                                                            append-outer-icon="help_outline"
                                                            @click:append-outer="help('product_upc')"
                                                        />
                                                        <div
                                                            v-if="is_item_disabled(product.own_upc)"
                                                        >
                                                            <v-icon color="red">report_problem</v-icon>
                                                            <span style="color:red">
                                                                Importante:
                                                                <br />
                                                            </span>
                                                            Se o código de barras inserido
                                                            <b>não</b>
                                                            for válido, seu produto pode ser recusado por algumas plataformas.
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </div>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 md12 lg4 class="mt-0 pl-2">
                            <v-card elevation="0" color style="height:100%; " class="pt-5">
                                <div
                                    v-if="!computed_cover"
                                    @click="open_image_dialog"
                                    class="mx-auto my-auto text-center"
                                    style='height: 250px; width: 250px;border:1px solid #999; background-color:#999;'
                                >   
                                    <v-icon
                                        dark
                                        class="my-auto mx-auto"
                                        style="margin-top: 125px!important; position:absolute; z-index:1;"
                                    >mdi-camera</v-icon>
                                    <v-img src="@/assets/help/product/CAPA.jpg" />
                                </div>

                                <div
                                    v-if="computed_cover"
                                    class="mx-auto my-auto"
                                    style="height: 250px; width: 250px;"
                                >
                                    <v-img
                                        v-if="computed_cover"
                                        :src="computed_cover"
                                        height="250px"
                                    ></v-img>
                                </div>

                                <div class="mx-auto my-auto text-center" style="width:80%">
                                    <v-btn
                                        color="red"
                                        v-if="computed_cover"
                                        dark
                                        @click="removeImage"
                                    >trocar imagem</v-btn>
                                    <v-file-input
                                        class="caption font-weight-bold"
                                        v-if="!computed_cover"
                                        accept="image/png, image/jpeg"
                                        placeholder="Anexe sua capa com nome do produto e nome do artista principal"
                                        append-outer-icon="help_outline"
                                        @change="onFileChange"
                                        @click:append-outer="help('product_cover')"
                                        v-model="item_cover"
                                        ref="cover_ref"
                                        messages="A capa precisa ser um JPEG ou PNG quadrado. Dimensões minímas de 1500x1500 (pixels), recomendamos 3000x3000 . Máximo de 3MB."
                                        :loading="sending_cover_loading"
                                    ></v-file-input>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
            </v-flex>
        </v-layout>

        <v-layout wrap mx-5  mb-5 style=""><!--border:1px solid #ccc-->            
            <v-flex xs12 sm12 md12 lg12 pb-2>
                <v-card elevation="0">
                    <v-card-title style="color:#222" class="target_faixa">
                        Faixas
                        <v-spacer></v-spacer>
                        <v-btn class="ml-5" dark elevation="0" color="blue" @click="add_faixa()">
                            <v-icon>mdi-plus</v-icon>FAIXA
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <div class="py-5">
                        <div v-if="tracks.length==0">
                            <h3
                                class="text-center"
                                style="color:#777"
                            >Seu produto ainda não contém faixas, adicione uma!</h3>
                        </div>

                        <v-tabs
                            v-model="tab"
                            background-color="#fafafa"
                            color="indigo"
                            v-show="tracks.length>=1"
                        >
                            <v-tab
                                v-for="(track, indice) in tracks"
                                :key="indice"
                            >Faixa {{indice + 1}}</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="(track, indice) in tracks" :key="indice">
                                <v-layout wrap >
                                    <v-flex xs12 md12 pt-1 pb-1 mb-5 pr-5>
                                        <v-layout style="background-color:#ECEFF1">
                                            <v-flex align-self-center  pl-2> <b>{{track.name}} </b></v-flex>
                                            <v-flex
                                                class="mx-auto my-auto text-right"
                                                    align-self-center
                                                
                                                >
                                                <v-tooltip fixed top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            @click="ver_faixa()"
                                                            dark
                                                            fab
                                                            small
                                                            elevation="1"
                                                            class="ml-4"
                                                            color="primary"
                                                            v-on="on"
                                                        >
                                                            <v-icon>edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar esta faixa do produto</span>
                                                </v-tooltip>
                                                <v-tooltip fixed top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            outlined
                                                            fab
                                                            small
                                                            elevation="1"
                                                            @click="move_faixa(indice, 'sobe', track)"
                                                            v-if="indice>0"
                                                            class="ml-4"
                                                            v-on="on"
                                                        >
                                                            <v-icon>keyboard_arrow_left</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Mover esta faixa para a esquerda</span>
                                                </v-tooltip>
                                                
                                                <v-tooltip fixed top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            outlined
                                                            fab
                                                            small
                                                            elevation="1"
                                                            @click="move_faixa(indice, 'desce', track)"
                                                            v-if="indice<tracks.length-1"
                                                            class="ml-4"
                                                            v-on="on"
                                                        >
                                                            <v-icon>keyboard_arrow_right</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Mover esta faixa para a direita</span>
                                                </v-tooltip>

                                                <v-tooltip fixed top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            @click="remove_faixa(track.id)"
                                                            dark
                                                            fab
                                                            small
                                                            elevation="1"
                                                            class="ml-4"
                                                            color="red"
                                                            v-on="on"
                                                        >
                                                            <v-icon>remove</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Remover esta faixa do produto</span>
                                                </v-tooltip>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 md12 px-2 py-5 style="border:1px solid #ccc;">
                                        <v-form @submit.prevent="salvar_rascunho" :id="`faixa${indice}`">
                                            <v-layout wrap>
                                            
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        class="purple-input text-capitalize"
                                                        label="Nome da faixa"
                                                        outlined
                                                        disabled
                                                        v-model="track.name"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md5 style="margin-left:15px;">
                                                    <v-select
                                                        v-model="track.works"
                                                        :items="$store.getters.obras"
                                                        label="Obras da faixa"
                                                        item-text="name"
                                                        outlined
                                                        multiple
                                                        disabled   
                                                        chips                                                       
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-layout wrap>
                                                        <v-flex xs12 sm4 pr-4>
                                                            <!--:disabled="(track.is_playback==1)"-->
                                                            <v-text-field
                                                                v-model="track.isrc_info.type"                                                                
                                                                label="Tipo de gravação"
                                                                item-text="name"
                                                                item-value="id"
                                                                disabled
                                                                outlined
                                                            ></v-text-field>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 pr-4>
                                                            <v-select
                                                                v-model="track.is_playback"
                                                                :items="[{name:'SIM',val:1},{name:'NÃO',val:0}]"
                                                                label="Playback?"
                                                                item-text="name"
                                                                item-value="val"
                                                                outlined
                                                                disabled                                                 
                                                            ></v-select>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 pr-4>
                                                            <v-select
                                                                v-model="track.is_instrumental"
                                                                :items="[{name:'SIM',val:1},{name:'NÃO',val:0}]"
                                                                label="Instrumental?"
                                                                item-text="name"
                                                                item-value="val"
                                                                outlined
                                                                disabled
                                                            ></v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm8 md12 my-2 align-self-center>
                                                            <v-select
                                                                v-model="track.feat_artists"
                                                                :items="track.feat_artists"
                                                                outlined
                                                                hide-selected
                                                                label="Participação Especial / Featuring Artists (feat) "
                                                                multiple
                                                                persistent-hint
                                                                chips                                                              
                                                                item-text="alias"
                                                                return-object
                                                                disabled
                                                            >
                                                            </v-select>
                                                        </v-flex>

                                                    </v-layout>
                                                </v-flex>                                      

                                                <v-layout                                                    
                                                    style=" background-color:#fefefe"
                                                    wrap
                                                >
                                                <v-flex xs12>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                                    <template
                                                        v-if="(Object.keys(track.isrc_info).length >1 || track.isrc_info.participantes)" 
                                                    >
                                                        <v-flex xs12 md12 align-self-center style="background-color:#fff;"
                                                        >  
                                                            <v-flex xs12 sm12 md8 align-self-center>
                                                                <v-text-field v-if="track.own_isrc == 1"
                                                                    class="purple-input"
                                                                    label="ISRC"
                                                                    outlined
                                                                    v-mask="'XX-XXX-#######'"
                                                                    disabled
                                                                    v-model="track.isrc"    
                                                                    style="margin-top:40px"                                                                
                                                                />                                                   
                                                            </v-flex>                                                                                                                  
                                                            <template v-if="track.isrc_info.participantes != null && track.own_isrc === 0">
                                                                <v-divider color="#fefefe"></v-divider>
                                                                <v-data-table
                                                                    :disable-filtering="true"
                                                                    :items-per-page="300"
                                                                    v-if="track.isrc_info.participantes"
                                                                    :items="track.isrc_info.participantes"
                                                                    :headers="[ {text:'Nome completo',value:'fullname'},
                                                                                {text:'Nome artistíco/pseudônimo',value:'alias'},
                                                                                {text:'CPF/CNPJ',value:'br_cpf_cnpj'},
                                                                                {text:'Função',value:'tipo.cat'},
                                                                                {text:'Instrumentos',value:'instrumentos'}
                                                                                ]"
                                                                    hide-default-footer
                                                                    hover
                                                                >
                                                                </v-data-table>
                                                            </template>
                                                        </v-flex>
                                                    </template>
                                                </v-layout>
                                            </v-layout>
                                        </v-form>
                                    </v-flex>

                                    

                                    <v-flex xs12 md12 pt-2 >
                                        <v-layout wrap fill-height>
                                            <v-flex xs12 md12 class v-show="track.name">
                                                <div class="mx-auto my-auto" style="width:100%;">
                                                    <v-layout wrap
                                                         style="width:100%;border:1px solid #ddd;min-height:100px;background: repeating-linear-gradient( 45deg, #F5F5F5, #F5F5F5 10px, #EEEEEE 10px, #EEEEEE 20px );"
                                                    >
                                                        <v-flex
                                                            xs12
                                                            sm8
                                                            v-show="audio_files[indice].state == 'nofile' || !audio_files[indice].state"
                                                            class="mx-auto my-auto text-center pb-3"
                                                            style="background-color:white"
                                                        >
                                                            <v-file-input
                                                                accept="audio/flac, audio/wav, audio/mpeg"
                                                                placeholder="Áudio da faixa"
                                                                messages="Dê prioridade para os arquivos no formato FLAC, WAV e MP3 com no máximo 60MB."
                                                                append-outer-icon="audiotrack"
                                                                @change="onFileChangeAudio"
                                                                @click="onSelectAudioFile(indice)"
                                                                :id="'fileupload_'+indice"
                                                            ></v-file-input>
                                                        </v-flex>
                                                        <v-flex
                                                            xs12
                                                            md12
                                                            class="text-center align-center mx-auto my-auto py-3"
                                                            v-show="audio_files[indice].state == 'readytoupload'"
                                                           
                                                        >
                                                            <v-btn
                                                                @click="uploadFile(indice)"
                                                                dark
                                                                class="mt-5 mx-auto my-auto"
                                                                color="success"
                                                            >
                                                                <v-icon dark>backup</v-icon>&nbsp;
                                                                Enviar ÁUDIO
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>
                                                <div
                                                    v-if="audio_files[indice].state == 'uploading'"
                                                    class="text-center align-center mx-auto my-auto pt-3"
                                                    style="width:100%;border:1px solid #ddd;min-height:100px"
                                                >
                                                    <p>
                                                        <v-progress-linear
                                                            :value="audio_files[indice].progress"
                                                            height="15"
                                                            striped
                                                            color="deep-orange"
                                                            class="mt-5"
                                                        >
                                                            <template v-slot="{ value }">
                                                                <strong>{{ Math.ceil(value) }}%</strong>
                                                            </template>
                                                        </v-progress-linear>
                                                    </p>
                                                </div>
                                                
                                                <div
                                                    v-show="audio_files[indice].state == 'uploaded'"
                                                    class="mx-auto my-auto text-center pb-3"
                                                    style="width:100%;border:1px solid #ddd;min-height:100px"
                                                >
                                                    <p class="py-2">ÁUDIO ENVIADO S</p>
                                                    <v-btn
                                                        dark
                                                        color="indigo"
                                                        @click="audio_files[indice].state = 'nofile'"
                                                    >Substituir Audio</v-btn>
                                                </div>
                                            </v-flex>
                                            
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout wrap mx-5 mb-5 style=""><!--border:1px solid #ccc-->
            <v-flex xs12 sm12 md12 lg12>
                <v-card elevation="0">
                    <v-card-title style="color:#222">
                        Plataformas
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>

                    <div>
                        <p
                            class="py-5 px-5"
                            style="font-size: 14px"
                        >Seu produto estará disponível nas plataformas selecionadas</p>
                        <v-layout wrap px-5>
                            <v-flex xs4 v-for="plataforma in plataformas" :key="plataforma.id">
                                <v-checkbox
                                    v-model="platforms"
                                    disabled
                                    :label="plataforma.name"
                                    :value="plataforma.id"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
        <NavSteppers @emit-close="ver_faixa()" @emit-salvar="salvar_rascunho()" :drawerStepper="drawer" :trackItem="tracks[tab]" :trackList="tracks" :indiceTrack="tab"></NavSteppers>

        <ProductHelp ref="product_help" />

        <modalmessage
            :dialog_opened="message.dialog_opened"
            :title="message.title"
            :message="message.message"
            btn_1_text="entendi"
            @btn_1_clicked="modalmessage_entendi"
            ref="modal"
        />
        <v-snackbar v-model="moved_track_order" :timeout="2000" right bottom color="sucess">
            Posição da faixa alterada
            <v-btn color="blue" text @click="moved_track_order = false">fechar</v-btn>
        </v-snackbar>

        <v-dialog v-model="dialog_adicionar_feat" persistent max-width="600px">                                              
            <v-card>
                <v-card-title>
                <span class="headline">Adicionar Participação/Feat</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>           
                            <v-col cols="12">
                        <v-text-field 
                            label="Nome artístico/Pseudônimo" 
                            v-model="dialog_feat_obj.alias"
                            outlined
                                tabindex="1"
                                
                            ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                        <v-text-field 
                            label="Nome completo" 
                            v-model="dialog_feat_obj.fullname"
                            outlined
                                tabindex="2"
                                
                            ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" >
                        <v-text-field
                                v-model="dialog_feat_obj.br_cpf_cnpj"						
                                outlined
                                label="CPF"
                                v-mask="'###.###.###-##'"
                                    tabindex="3"
                            
                            ></v-text-field>
                    </v-col>
                    
                    </v-row>
                </v-container>
                <small>todos os campos são obrigatórios</small>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog_adicionar_feat = false; dialog_feat_obj={}">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="adicionar_feat_to_track()">Adicionar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
    </v-sheet>
</template>
<style>
/**
 *Remove os botoes que são tipicos do input quando o type é field 
 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import VeeValidate from "vee-validate";
//components
import modalmessage from "../../../components/shared/modalmessage";
import ProductService from "../../../app/Rest/product";

import ProductHelp from "../../../components/help/product";

import {valida_cpf} from "../../../app/general"

import NavSteppers from "../Products/inc/NavigationSteppers"

Vue.use(VeeValidate);
let productService = null;

export default {
    $_veeValidate: {
        validator: "new"
    },
    components: {
        modalmessage,
        ProductHelp,
        NavSteppers
    },
    data: () => ({
        drawer: false,
        dialog_adicionar_feat:false,
        dialog_feat_obj:{},
        tab: null,
        release_date: null,
        moved_track_order: false,
        editable_product: null,
        audio_files: [],
        input_selected: null,
        cover: null,
        cover_file: null,
        sending_cover_loading: false,
        item_cover: null,
        panel_expanded: [0, 1, 2],
        tracks: [],
        modal: false,
        image_size: {},
        tmp_release_data: null,
        product: {
            type: "",
            record_label_name: "Nova Música Gospel",
            release_date: null,
            own_upc: 0
        },
        platforms: [],
        message: {
            dialog_opened: false,
            title: "",
            message: "",
            btn_1_text: ""
        },
        product_type_choosed: {},

        //dicionário de validação
        dictionary: {
            messages:{
                required:'Esse campo é obrigatório'
            },
            attributes:{
                tipo_gravacao:'Tipo gravação'
            },
            custom: {
                is_instrumental: {
                    required: "Se essa é pra ser somente instrumental?"
                },
                tipo_gravacao: {
                    required: "Precisamos saber se você gravou em estúdio, acustivo, ao vivo ...."
                },
                is_playback: {
                    required: "Marque 'SIM' somente se essa faixa inteira não tem a voz principal."
                },
                product_name: {
                    required: "O título do produto é bem importante, hein!"
                },
                type: {
                    required: "O formato do produto é obrigatório"
                },
                track_name: {
                    required: "O nome da faixa é obrigatório"
                },
                obras: {
                    required:
                        "É necessário ao menos uma obra vinculada a esse fonograma"
                },
                release_date: {
                    required:
                        "Data de lançamento é obrigatório, mesmo que seja para uma data no passado."
                },
                copyright_year: {
                    required: "Ano de copyright é obrigatório."
                },
                copyright: {
                    required: "Copyright do Produto é obrigatório."
                },
                copyright_phonogram: {
                    required: "Copyright da Gravação é obrigatório."
                }
            }
        }
    }),
    
    mounted() {
        this.$validator.localize("ptbr", this.dictionary);
        if (this.$store.getters.obras.length == 0) {
            this.$refs.modal.show({
                title: "Você não tem nenhuma OBRA MUSICAL cadastrada.",
                message: "Você precisa ter pelo menos <b>uma</b> obra musical para poder montar e distribuir seu Single, EP ou Álbum",
                btn_1_text: "CADASTRAR DEPOIS",
                btn_2_text: "CADASTRAR AGORA",
                btn_2_action: () => {
                    return this.$router.push({ name: "work_add" });
                }
            });
        }

       
    },
    computed: {
        ...mapGetters(["configs", "artist"]),
        min_date_datepicker:function(){
            //20 dias de espera
            return new Date(new Date().getTime()+(20*24*60*60*1000)).toISOString();
        },
        formated_date: function() {
            return this.formatDate(this.release_date);
        },
        page_title() {
            if (this.product.id) {
                return (
                    "EDITANDO" +
                    (!this.$vuetify.breakpoint.smAndUp
                        ? ""
                        : " > " + this.product.name)
                );
            } else {
                return "NOVO PRODUTO";
            }
        },
        plataformas() {
            return this.configs.platforms.filter(e => {
                if (["content_match", "streaming"].indexOf(e.type) >= 0) {
                    return true;
                }
                return false;
            });
        },
        computed_cover() {
            if (this.product.thumbnail) {              
                return (this.product.thumbnail.indexOf("googleapis")>=0) ? this.product.thumbnail : process.env.VUE_APP_BASE_URL + this.product.thumbnail;
            } else if (this.thumbnail != null) {
                return this.thumbnail;
            } else {
                return false;
            }
        }
    },
    beforeCreate: function() {
        productService = ProductService.build();

        if (this.$route.params)
            this.editable_product =
                this.$route.params.id == undefined
                    ? false
                    : this.$route.params.id;

        if (!this.editable_product) {
            return;
        }

        this.$store.dispatch("loading_full");
        productService
            .getOne(this.editable_product)
            .then(e => {
                if (e.items) {
                    this.product = e.items.product;
                    this.update_tracks_info(e.items.tracks);
                    this.cover = this.product.thumbnail;

                      //renderiza as abas se forem maior que 1, ajuda na validação
                    //@todo remover daqui
                    if(this.tracks.length>1 && this.force_render_faixa_tabs ==null){
                        this.tracks.map( (e,o)=>{
                            setTimeout( ()=>{
                                this.tab = (this.tracks.length -1) - o;                            
                            },300);
                        });
                        this.force_render_faixa_tabs = true;
                    }        
                    
                } else {
                    this.$store.dispatch("loading_full", false);
                    this.$refs.modal.show({
                        title: "Não encontrado",
                        message: "O produto buscado não foi encontrado",
                        btn_1_text: "Entendi",
                        btn_1_action: () => {
                            this.$router.push({ name: "products" });
                        }
                    });
                }
            })
            .finally(() => {
                this.$store.dispatch("loading_full", false);
               
            });
    },
    created() {
        this.platforms = this.plataformas.map(e => {
            return e.id;
        });

       
    },
    watch: {
        "product.type": {
            handler: function(type_id) {
                let type = this.configs.product_types.filter(e => {
                    if (type_id == e.id) {
                        return true;
                    }
                    return false;
                })[0];

                this.product_type_choosed = type;
                if (typeof this.product_type_choosed != "object") {
                    return;
                }

                if (this.product_type_choosed.slug == "single") {
                    //console.log("single choosed");
                }
            },
            deep: true
        },
        "product.release_date": {
            handler: function(e,g) {
                //console.log('rlease_date: ',e,g)
                if (
                    this.product.release_date == null ||
                    this.product.status != "draft"
                ) {
                    this.release_date = this.product.release_date;
                    this.tmp_release_data = this.release_date;
                
                    return ;
                }

                this.release_date = this.product.release_date;
                var release = new Date(this.product.release_date);
                var ideal = new Date();
                ideal.setDate(ideal.getDate() + 19);

                //console.log(this.tmp_release_data, " -- ", release);
                if (
                    release < ideal &&
                    this.release_date != this.tmp_release_data
                ) {
                    this.$refs.modal.show(
                        "Atenção",
                        "Recomendamos o mínimo de 20 dias a contar de hoje para a data do lançamento e não nos responsabilizamos por esses prazos menores. <br><br><b>Entenda:</b>" +
                            "<br>Com uma data menor os produtos podem ser liberados em dias diferentes do esperado.<br>" +
                            "Isso ocorre porque cada plataforma de streaming/venda tem o seu tempo para produzir e preprar o seu produto.<br><br>" +
                            "Mantendo a nossa recomendação faremos de tudo para que o seu produto esteja em todas as plataformas ao mesmo tempo no dia estipulado!<br>" +
                            "",
                        "Entendi"
                    );

                    this.tmp_release_data = this.release_date;
                }
            },
            deep: true
        },
        item_cover() {
            if (!this.item_cover) {
                this.cover = null;
            }
        },
        audio_files: {
            handler() {
                //faz nada
            },
            deep: true
        },
        tab() {
           //console.log("tab ", this.tab);
        }
    },
    methods: {
        formatDate(date) {
            if (!date){ 
                console.log("format date-> ", date);
                return null
            };

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        saveDate(date) {
            this.product.release_date = date;
            this.release_date = date;
        },
        help(tag) {
            this.$refs.product_help.show(tag);
        },
        move_faixa(indice, movimento, obj) {
            let _n = [];
            let nova_posicao = 0;
            if (movimento == "sobe") {
                nova_posicao = indice - 1;
            } else {
                nova_posicao = indice + 1;
            }

            this.tracks.forEach((item, index) => {
                if (indice == index) {
                    return;
                }
                if (nova_posicao == index) {
                    if (movimento == "sobe") {
                        _n.push(obj);
                        _n.push(item);
                    } else {
                        _n.push(item);
                        _n.push(obj);
                    }
                } else {
                    _n.push(item);
                }
            });

            this.moved_track_order = true;
            this.tab = nova_posicao;
            this.update_tracks_info(_n);
        },
        open_image_dialog() {
            this.$refs.cover_ref.$el.children[1].blur();
            this.$refs.cover_ref.$el.children[1].click();
            this.$refs.cover_ref.$el.children[1].focus();
        },
        modalmessage_entendi() {
            this.message.dialog_opened = false;
        },
        salvar_rascunho() {
            return new Promise((resolve, reject) => {
                this.$validator.validate("product_name").then(is_valid => {
                    if (!is_valid) {
                        this.$refs.modal.show(
                            "Salvando o rascunho",
                            'Para salvar o rascunho o campo de "Nome do Produto" precisa ser preenchido.',
                            "Entendi"
                        );
                        return;
                    }

                    var _product = this.product;
                    //caso não esteja já definido
                    if (!_product.main_artist) {
                        _product.main_artist = this.artist.id;
                    }

                    _product.tracks = this.tracks;
                    this.$store.dispatch("loading_full");
                    productService
                        .saveMetadata(_product)
                        .then(e => {
                            this.product = e.items.product;
                            this.update_tracks_info(e.items.tracks);
                            resolve();
                        })
                        .finally(e => {
                            this.$store.dispatch("loading_full", false);
                        });
                });
            });
        },

        /**
         * Pega o indice do input file para o audio quando clicado
         */
        onSelectAudioFile(indice) {
            //this.$refs.inputUpload[indice].click();
            this.input_selected = indice;
            //console.log("onSelectAudioFile", this.input_selected);
            if (!this.audio_files[this.input_selected]) {
                this.audio_files[this.input_selected] = {};
            }
        },
        /**
         * Quando o arquivo é alterado no campo esses são preenchidos
         */
        onFileChangeAudio(audio, event) {
            if (!audio) {
                return;
            }
            var audio_extension = audio.name.split('.');
            audio_extension = audio_extension[audio_extension.length-1];
            if( ['audio/wav','audio/flac','audio/mp3','audio/mpeg'].indexOf(audio.type)<0 &&
                ['mpga'].indexOf(audio_extension) <0
            ){ 
                this.$refs.modal.show("Atenção","Esse áudio não parece ser válido.<br><br>Por favor nos envie um arquivo no formado WAV, FLAC ou MP3.","Entendi");
                return;
            }

            if (audio.size > 100000000) {
                this.$refs.modal.show(
                    "Áudio muito grande",
                    "Por favor nos envie uma música com até 80MB",
                    "entendi"
                );
                //resetar o campo
                document.getElementById(
                    "fileupload_" + this.input_selected
                ).previousSibling.innerHTML = "";
                document.getElementById(
                    "fileupload_" + this.input_selected
                ).value = "";

                return;
            }

            this.audio_files[this.input_selected].color = "success";
            this.audio_files[this.input_selected].file = audio;
            this.audio_files[this.input_selected].state = "readytoupload";
            this.audio_files[this.input_selected].track_id = this.tracks[
                this.input_selected
            ].id;
        },
        /**
         * Quando houver alteração no campo de input da imagem
         */
        onFileChange(e, ee) {
            if (e == null) return;
            this.createImage(e);
        },
        createImage(file) {
            var reader = new FileReader();

            reader.onload = e => {
                var _image = new Image();
                _image.src = e.target.result;
                this.cover = _image.src; //e.target.result;
                _image.onload = e => {
                    this.image_size = {
                        width: _image.width,
                        height: _image.height
                    };
                    this.image_size_check();
                };
                this.cover_file = file;
            };
            reader.readAsDataURL(file);
        },
        removeImage: function() {
            //this.cover = null;
            //this.product.cover = null;
            this.thumbnail = this.product.thumbnail = this.cover = this.item_cover = this.product.cover = null;
            //this.cover_file = "";
        },
        uploadCover() {
            if (!this.product.id) {
                this.$refs.modal.show(
                    "Ops",
                    "Clique primeiro em salvar rascunho antes de adicionar uma capa.",
                    "entendi"
                );
                this.removeImage();
                return;
            }

            if (this.cover_file == null) {
                return;
            }

            this.sending_cover_loading = true;
            let params = {
                product_id: this.product.id,
                cover: this.cover_file
            };

            this.$store.dispatch("loading_full");
            productService
                .sendCover(params)
                .then(e => {
                    //console.log("retorno do sendCover");
                    //console.log(e);
                    this.product.cover = e.items.cover;
                    this.product.thumbnail = e.items.thumbnail;
                })
                .catch(e => {
                    this.cover = null;
                    this.item_cover = null;
                })
                .finally(e => {
                    this.sending_cover_loading = false;
                    this.$store.dispatch("loading_full", false);
                });
        },
        update_tracks_info(_tracks) {
            //manter o estado atual dos arquivos
            var _audiofiles = [];
            //this.audio_files = [];

            this.tracks = _tracks.map((rr, track_index) => {                

                let _trk = this.audio_files.filter(e => {                  

                    if (e.track_id == rr.id) {
                        return true;
                    }
                    return false;
                });

                //se o audio_file já estiver definido, mantemos o estado atual dele.
                if (_trk.length > 0) {
                    _audiofiles.push(_trk[0]);
                } else {
                    //indicamos aqui o push
                    _audiofiles.push({
                        audio_file: rr.audio_path,
                        state: rr.audio_path ? "uploaded" : "nofile",
                        track_id: rr.id,
                        progress: 0
                    });
                }


                if (!rr.isrc_info || rr.isrc_info == null || rr.isrc_info == '""' || rr.isrc_info == "[]") {
                    rr.isrc_info = {type: "STUDIO", participantes: []} 
                }
                else{
                   if( typeof(rr.isrc_info) =="string"){
                        rr.isrc_info = JSON.parse( rr.isrc_info);
                        if(typeof(rr.isrc_info) == "string"){
                            rr.isrc_info = JSON.parse( rr.isrc_info);
                        }
                    }
                }
                if(rr.feat_artists == undefined || rr.feat_artists == "" || rr.feat_artists == '""'){
                    rr.feat_artists = [];
                }else{
                    if( typeof(rr.feat_artists) =="string"){
                        rr.feat_artists = JSON.parse( rr.feat_artists);
                        if( typeof(rr.feat_artists) =="string"){
                            rr.feat_artists = JSON.parse( rr.feat_artists);
                        }
                    }
                }

                if(rr.isrc_info.participantes == undefined ){
                    rr.isrc_info.participantes = [];                    
                }
                
                return rr;
            });

            this.panel_expanded = this.tracks.map((e, i) => {
                return i + 1;
            });
            this.audio_files = _audiofiles;
        },
        /**
         * Upload do arquivo de áudio
         */
        uploadFile(indice) {
            this.salvar_rascunho().then(e => {                

                this.audio_files[indice].state = "uploading";
                var params = {
                    track_id: this.audio_files[indice].track_id,
                    product_id: this.product.id,
                    audio: this.audio_files[indice].file
                };

                productService
                    .sendAudioFile(params, {
                        onUploadProgress: progressEvent => {
                            
                            this.audio_files[indice].progress = Math.round(
                                (progressEvent.loaded * 100) /
                                    progressEvent.total
                            );                            
                        }
                    })
                    .then(e => {                        
                        this.audio_files[indice].state = "uploaded";
                        this.$set(this.tracks, indice, e.items.track);
                    })
                    .catch(e => {
                        alert("Deu algum problema na subida do áudio");
                        this.audio_files[indice].state = "readytoupload";
                    });
            });
        },
        //FAIXAS
        add_faixa: function() {
            if (!this.product.name) {
                this.$refs.modal.show(
                    "",
                    'Para adicionar uma faixa é necessário que o campo "Nome do Produto" esteja preenchido.',
                    "Entendi"
                );
                return;
            }

            if (this.product_type_choosed == null) {
                this.$refs.modal.show(
                    "Formato de produto",
                    "Escolha um formato de produto antes de adicionar a sua primeira faixa.",
                    "Entendi"
                );
                return;
            }
            if (this.product_type_choosed.max_tracks < this.tracks.length + 1) {
                this.$refs.modal.show(
                    "Limite no número de faixas",
                    `${this.product_type_choosed.name} suporta o máximo de ${this.product_type_choosed.max_tracks} faixa(s)`,
                    "Entendi"
                );

                return;
            }
            let _tracks = JSON.parse(JSON.stringify(this.tracks));

            _tracks.push({
                order: this.tracks.length + 1,
                nome: null,
                own_isrc: 0,
                works: [],
                artists: [],
                isrc: null,
                isrc_info: {
                    type: "STUDIO",
                    participantes: []
                }     
            });

            this.update_tracks_info(_tracks);
            this.tab = _tracks.length - 1;
            this.salvar_rascunho().then(() => {
                if(!this.drawer){
                    this.ver_faixa();
                    console.log("adicionou e veio aqui ver_faixa");
                }
            });
        },
        remove_faixa: function(indice) {
            this.$refs.modal.show({
                title: "Tem certeza?",
                message:
                    "Removendo essa faixa todos os dados vinculados a ela serão deletados.",
                btn_1_text: "Cancelar",
                btn_2_text: "Deletar",
                btn_2_action: () => {
                    var t_faixas = [];
                    this.tracks.forEach(element => {
                        if (indice != element.id) {
                            t_faixas.push(element);
                        }
                    });

                    this.update_tracks_info(t_faixas);
                }
            });
        },
        distribuir() {
                 

            this.$validator.validateAll().then(is_valid => {                
                if (!is_valid) {
                    
                    this.$refs.modal.show(
                        "Para distribuir",
                        "<p>Os campos em vermelho são obrigatórios para que você distribua o seu conteúdo corretamente.</p><p>Alguns campos podem aparecer em vermelho mesmo preenchidos, isso significa que há um campo similiar que não está preenchido.</p>",
                        "Entendi"
                    );
                    //apontar a aba correta do erro no caso da faixa
                    var faixa_erro_tab = null;
                    this.$validator.errors.items.map( e=>{
                        if(e.field.indexOf('faixa')>=0 && faixa_erro_tab == null ){
                            var f = e.field.split(".")[0].replace("faixa","");
                            faixa_erro_tab = f;
                            this.tab = parseInt(faixa_erro_tab);
                            this.$vuetify.goTo('.target_faixa');
                        }
                    })
                    return;
                }

                if( this.tracks.length == 0){
                     this.$refs.modal.show(
                        "Para distribuir",
                        "<p>É necessário que tenha ao menos uma faixa cadastrada. <br> Clique no botão \"+ FAIXA\" para adicionar uma.</p>",
                        "Entendi"
                    );
                    return;
                }else{
                    //verificamos se tem obras
                    let sem_obra = false;
                    this.tracks.map( e=>{
                        if(e.works.length==0){
                            sem_obra = true;
                        }
                    });

                    if(sem_obra){
                        this.$refs.modal.show(
                        "Para distribuir",
                        "<p>Todas as faixas precisam ter uma obra selecionada.</p>",
                        "Entendi"
                    );
                    }
                }

                //validamos se as faixas que teremos que gerar o isrc estão com as informações do ISRC
                var _tracks_incompletas = this.tracks.filter(e=>{
                    if(e.own_isrc == 0 && (e.isrc_info == undefined || e.isrc_info.participantes ==undefined || e.isrc_info.participantes.length == 0)){
                        return true;
                    }
                    return false;
                })
                if(_tracks_incompletas.length>0){
                    this.$refs.modal.show(
                            "Informações adicionais obrigatórias",
                            "Para gerarmos o seu ISRC precisamos das informações também do produto fonográfico, interpretes (individualmente) e de cada músico com os instrumentos que tocou.<br><br>Clique no botão + INFORMAÇÕES ADICIONAIS para inserir esses dados.",
                            "Entendi"
                        );
                        this.$vuetify.goTo('.target_btn_informacoes_adicionais');
                    return;
                }



                if (this.product.own_upc) {
                    if (this.product.upc == null || this.product.upc == "" || this.product.upc.length != 13) {
                        this.product.upc = "";
                        this.$refs.modal.show(
                            "Código de barras inválido?",
                            "O código de barras que você digitou parece inválido.<br><br>Se você não tiver um código de barras válido você pode adquirir um.",
                            "Entendi"
                        );
                        return;
                    }
                }

                let _typeescolhido = this.configs.product_types.filter(e => {
                    return e.id == this.product.type ? true : false;
                })[0];

                if (_typeescolhido.slug != "single") {
                    if (this.tracks.length == 1) {
                        this.$refs.modal.show(
                            "Atenção",
                            `Você selecionou '${_typeescolhido.name}' mas só adicionou uma faixa, recomendamos trocar o formato do produto para single.`,
                            "entendi"
                        );
                        return;
                    }
                }

                //Nome da faixa deve ser igual ao nome do produto
                if (_typeescolhido.slug == "single") {
                    if (this.product.name != this.tracks[0].name) {
                        this.$refs.modal.show(
                            "Atenção",
                            `Para o single, o nome do produto e da faixa devem ser exatamente iguais.`,
                            "entendi"
                        );
                        return;
                    }
                }

                var faixas_falta_audio = [];
                this.tracks.map(function(e) {
                    if (!e.audio_path) {
                        faixas_falta_audio.push(e);
                    }
                });

                if (faixas_falta_audio.length > 0) {
                    var erros = "";
                    faixas_falta_audio.map(e => {
                        erros += "<p style='color:red'>- " + e.name + "</p>";
                    });
                    this.$refs.modal.show(
                        "Para distribuir",
                        "<p>Parece que falta um ou mais arquivos de áudio. Nas faixas abaixo.</p> " +
                            erros,
                        "Entendi"
                    );

                    return;
                }

                if (!this.product.cover) {
                    this.$refs.modal.show(
                        "Para distribuir",
                        "<p>Ficou faltando só a capa!</p>",
                        "Entendi"
                    );

                    return;
                }

                //tudo certo, vamos para o pagamento
                this.salvar_rascunho().then(e => {
                    let _product = this.product;
                    _product.tracks = this.tracks;
                    this.$router.push({
                        name: "payment",
                        params: { product: _product }
                    });
                });
            });
        },
        
        image_size_check() {
            if (typeof this.image_size != "object") {
                return null;
            }

            /**
             * Validamos se a imagem é quadrada primeiro
             */
            if (this.image_size.width !== this.image_size.height) {
                this.$refs.modal.show(
                    "A imagem precisa ser quadrada!",
                    "As plataformas exigem que as imagens de capa sejam quadradas. Envie uma imagem com no minímo 1500x1500.",
                    "Entendi"
                );
                this.cover = null;
                this.item_cover = null;

                return false;
            }

            /**
             * Validamos se ela tem no minimo de 1500 por 1500
             */
            if (this.image_size.width < 1500) {
                this.$refs.modal.show(
                    "Quase lá!",
                    "Envie uma imagem com no minímo 1500px de largura por 1500px de altura.",
                    "Entendi"
                );

                this.cover = null;
                this.item_cover = null;
                return false;
            }

            this.uploadCover();
        },
        is_item_disabled(val) {
            return val ? true : false;
        },
        ver_faixa() {
            console.log("ver faixa");
            console.log(this.drawer);

            this.drawer = !this.drawer;
        }
    }
};
</script>
